import React from 'react';
import Icon from '@ant-design/icons';
import { DataType } from '@kemu-io/hs-types';
import { ReactComponent as JsonWidgetIcon } from '@src/assets/img/dataTypes/jsonIcon.svg';
import { ReactComponent as NumberIcon } from '@src/assets/img/dataTypes/numberIcon.svg';
import { ReactComponent as StringIcon } from '@src/assets/img/dataTypes/stringIcon.svg';
import { ReactComponent as ArrayIcon } from '@src/assets/img/dataTypes/arrayIcon.svg';
import { ReactComponent as ImageIcon } from '@src/assets/img/dataTypes/imageIcon.svg';
import { ReactComponent as AnythingIcon } from '@src/assets/img/dataTypes/anythingIcon.svg';
import { ReactComponent as BooleanIcon } from '@src/assets/img/dataTypes/booleanIcon.svg';
import { ReactComponent as RectIcon } from '@src/assets/img/dataTypes/rectIcon.svg';
import { ReactComponent as ArrayBufferIcon } from '@src/assets/img/dataTypes/arrayBufferIcon.svg';
import { ReactComponent as AudioBufferIcon } from '@src/assets/img/dataTypes/audioBufferIcon.svg';
import { ReactComponent as BinaryFileIcon } from '@src/assets/img/dataTypes/binaryFileIcon.svg';

type Props = {
  dataType: DataType;
  className?: string;
}

/**
 * Common component that renders the appropriate icon for a given DataType
 * @param dataType - The DataType to render an icon for
 * @param className - Optional CSS class name to apply to the icon
 * @returns JSX element with the appropriate icon
 */
const DataTypeIcon = (props: Props) => {
  const { dataType, className } = props;

  const getIconComponent = () => {
    switch (dataType) {
      case DataType.Number:
        return <Icon component={NumberIcon} className={className} />;
      case DataType.String:
        return <Icon component={StringIcon} className={className} />;
      case DataType.Array:
        return <Icon component={ArrayIcon} className={className} />;
      case DataType.JsonObj:
        return <Icon component={JsonWidgetIcon} className={className} />;
      case DataType.ImageData:
        return <Icon component={ImageIcon} className={className} />;
      case DataType.Boolean:
        return <Icon component={BooleanIcon} className={className} />;
      case DataType.Rect:
        return <Icon component={RectIcon} className={className} />;
      case DataType.BinaryFile:
        return <Icon component={BinaryFileIcon} className={className} />;
      case DataType.ArrayBuffer:
        return <Icon component={ArrayBufferIcon} className={className} />;
      case DataType.AudioBuffer:
        return <Icon component={AudioBufferIcon} className={className} />;
      case DataType.Anything:
        return <Icon component={AnythingIcon} className={className} />;
      default:
        return <Icon component={AnythingIcon} className={className} />;
    }
  };

  return getIconComponent();
};

export default DataTypeIcon;
